import { INTRODUCER_KEY_TYPE } from "@/shared/model";
import * as z from "zod";

const commonSchema = z.object({
	managerId: z.string(),
	introducerType: INTRODUCER_KEY_TYPE,
	introducedDate: z.string().nullable(),
	introducedCustomerId: z.string().nullable(),

	memo: z.string().nullable(),
	content: z.string(),
	files: z.array(z.string()).optional()
});

const taxAccountantScheme = commonSchema.extend({
	introducerType: z.literal("TAX_ACCOUNTANT"),
	introducerTaxAccountantId: z.string()
});

// "TP", "ACQUAINTANCE", "ETC"
const customerScheme = commonSchema.extend({
	introducerType: z.union([z.literal("TP"), z.literal("ACQUAINTANCE"), z.literal("ETC")]),
	introducerCustomerId: z.string()
});

const employeeScheme = commonSchema.extend({
	introducerType: z.literal("MYSELF"),
	introducerEmployeeId: z.string()
});

const schema = z.discriminatedUnion("introducerType", [taxAccountantScheme, customerScheme, employeeScheme]);

const model = schema.transform((values) => ({
	...values
}));

export const CustomerManagementRegisterV2Model = { schema, model };
export type ICustomerManagementRegisterV2Model = z.infer<typeof CustomerManagementRegisterV2Model.model>;
export const DEFAULT_CUSTOMER_MANAGEMENT_REGISTER_FORM: ICustomerManagementRegisterV2Model = {
	managerId: "",
	introducerType: "TAX_ACCOUNTANT",
	introducerTaxAccountantId: "",
	introducedDate: "",
	introducedCustomerId: "",
	memo: "",
	content: "",
	files: []
};
